<app-link
  link="/real-property-agent"
  [id]="id"
  [queryParams]="queryParams">
  <ng-content></ng-content>
</app-link>
